const dateISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:[.,]\d+)?Z?$/i;
const dateNet = /\/Date\((-?\d+)(?:[+-]\d+)?\)\//i;
export function dateFromString(date) {
    if (typeof date === 'object') {
        return date;
    }
    if (dateISO.test(date)) {
        // Truncate milliseconds because Date.UTC returns invalid results when milliseconds is >999
        const d = date.split(/\D+/).map((s, index) => (index === 6 ? +s.substring(0, 3) : +s));
        return new Date(Date.UTC(d[0], --d[1], d[2], d[3], d[4], d[5], d[6]));
    }
    if (dateNet.test(date)) {
        const parsedDate = dateNet.exec(date);
        if (parsedDate !== null) {
            return new Date(parseInt(parsedDate[1], 10));
        }
    }
    throw new Error('Incorrect date format');
}
//# sourceMappingURL=date-from-string.js.map